"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useDialog;
const vue_demi_1 = require("vue-demi");
function useDialog(dialogId) {
    let visible = (0, vue_demi_1.ref)(false);
    return {
        visible,
        show() {
            visible.value = true;
            (0, vue_demi_1.nextTick)(() => {
                const element = document.getElementById(dialogId);
                if (element) {
                    document.body.appendChild(element);
                }
            });
        },
        hide() {
            visible.value = false;
            (0, vue_demi_1.nextTick)(() => {
                const element = document.getElementById(dialogId);
                if (element && element.parentNode) {
                    element.parentNode.removeChild(element);
                }
            });
        },
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlhbG9nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZGlhbG9nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQ0EsNEJBdUJDO0FBeEJELHVDQUF5QztBQUN6QyxTQUF3QixTQUFTLENBQUMsUUFBZ0I7SUFDOUMsSUFBSSxPQUFPLEdBQUcsSUFBQSxjQUFHLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFDekIsT0FBTztRQUNILE9BQU87UUFDUCxJQUFJO1lBQ0EsT0FBTyxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUM7WUFDckIsSUFBQSxtQkFBUSxFQUFDLEdBQUcsRUFBRTtnQkFDVixNQUFNLE9BQU8sR0FBRyxRQUFRLENBQUMsY0FBYyxDQUFDLFFBQVEsQ0FBQyxDQUFDO2dCQUNsRCxJQUFJLE9BQU8sRUFBRSxDQUFDO29CQUNWLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDO2dCQUN2QyxDQUFDO1lBQ0wsQ0FBQyxDQUFDLENBQUM7UUFDUCxDQUFDO1FBQ0QsSUFBSTtZQUNBLE9BQU8sQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO1lBQ3RCLElBQUEsbUJBQVEsRUFBQyxHQUFHLEVBQUU7Z0JBQ1YsTUFBTSxPQUFPLEdBQUcsUUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLENBQUMsQ0FBQztnQkFDbEQsSUFBSSxPQUFPLElBQUksT0FBTyxDQUFDLFVBQVUsRUFBRSxDQUFDO29CQUNoQyxPQUFPLENBQUMsVUFBVSxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQztnQkFDNUMsQ0FBQztZQUNMLENBQUMsQ0FBQyxDQUFDO1FBQ1AsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDIn0=